export const promisedImgFromBase64 = (base64String: string): Promise<HTMLImageElement> => {
  const img = document.createElement('img')
  img.src = base64String
  return new Promise<any>((resolve, reject) => {
    img.onload = () => {
      resolve(img)
    }
    img.onerror = () => {
      reject(img)
    }
  })
}
